"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const white = '#ffffff';
const black = '#000000';
const brandBlue = '#0082ff';
const modalOverlay = '#21212160';
const gray = {
  50: '#f6f7f9',
  100: '#e1e6ec',
  200: '#cbd4de',
  300: '#afbdcc',
  400: '#94a7ba',
  500: '#7890a8',
  600: '#537495',
  700: '#3b5261',
  800: '#2f3f4b',
  900: '#26323c'
};
const blue = {
  50: '#f6fbfd',
  100: '#e6f8fd',
  200: '#c0e9fb',
  300: '#96d3fa',
  400: '#5baafa',
  500: '#1271eb',
  600: '#1d58f2',
  700: '#1b46da',
  800: '#1735a6',
  900: '#132b7f'
};
const navy = {
  50: '#f4fafc',
  100: '#e4f7fb',
  200: '#bfebf6',
  300: '#92d9f4',
  400: '#51b7f0',
  500: '#2590ea',
  600: '#1a6cda',
  700: '#1b55b6',
  800: '#194185',
  900: '#002d5b'
};
const green = {
  50: '#ecf8f7',
  100: '#d3f7ef',
  200: '#a4f3d9',
  300: '#65eabf',
  400: '#1edb96',
  500: '#09c66a',
  600: '#08ad50',
  700: '#008547',
  800: '#11703e',
  900: '#115a35'
};
const yellow = {
  50: '#f9f5e5',
  100: '#faf0bd',
  200: '#f6e67c',
  300: '#f1d439',
  400: '#ffbf02',
  500: '#e19706',
  600: '#cf7404',
  700: '#ae5708',
  800: '#8e440e',
  900: '#743710'
};
const red = {
  50: '#fdf9f8',
  100: '#fdeef3',
  200: '#fbcee6',
  300: '#fba4d1',
  400: '#fc6bad',
  500: '#fc4086',
  600: '#f7265f',
  700: '#e01438',
  800: '#b4193c',
  900: '#901530'
};
const colors = {
  gray: {
    ...gray,
    light: gray['50'],
    medium: gray['200'],
    dark: gray['600']
  },
  blue,
  navy,
  red: {
    ...red,
    default: red['700']
  },
  green: {
    ...green,
    default: green['700']
  },
  yellow: {
    ...yellow,
    default: yellow['400']
  },
  primary: {
    ...blue,
    default: blue['500']
  },
  secondary: {
    ...navy,
    default: navy['900']
  },
  success: green['700'],
  warning: yellow['400'],
  error: red['700'],
  accent: gray['200'],
  text: {
    primary: {
      light: black,
      dark: white
    },
    secondary: {
      light: gray['600']
    },
    link: {
      light: blue['500'],
      dark: white
    }
  },
  background: {
    gray: gray['50'],
    white
  },
  white,
  black,
  brandBlue,
  modalOverlay
};
var _default = exports.default = colors;